<template>
<section id="target-item">
  <ul>
    <li>
      <div class="target-item-img">
        <span class="target-item-img-wrap com-item-box">
          <img class="item-box-image" v-if="item.image && item.image.length > 0" :src="item.image[0].postar_file_path ?  item.image[0].postar_file_path :  item.image[0].file_path" alt="">
          <img class="item-box-image" v-else src="@/assets/images/no_photo.jpg" alt="">
          <span v-if="item.attention_info" v-bind:class="{'fav-mark': true, 'active': item.attention_info.is_favorited}" @click="favoriteItem(item.attention_info.is_favorited);item.attention_info.is_favorited=!item.attention_info.is_favorited"></span>
        </span>
      </div>
      <div class="target-item-txt">
        <div class="header-info">
          <p class="target-item-no" v-if="item.lot_id">{{item.lot_id}}</p>
          <p class="stock-location" v-if="false && item.area_id">{{getAreaName(item.area_id)}}</p>
          <p class="stock-location" v-if="false && !item.area_id && item.free_field && item.free_field.SYBSNM">{{item.free_field.SYBSNM}}</p>
          <p class="target-item-system">{{$t(parent.typeTag)}}</p>
        </div>
        <div class="target-item-data">
          <div class="detail-block">
            <dl>
              <dt>{{$t("DETAIL_CATEGORY_LABEL")}}</dt>
              <dd class="category">{{getCategory(item.free_field.category)}}</dd>
            </dl>
            <dl>
              <dt>{{$t("DETAIL_OWNER_LABEL")}}</dt>
              <dd>{{item.free_field.owner}}</dd>
            </dl>
            <dl>
              <dt>{{$t("DETAIL_WEIGHT_LABEL")}}</dt>
              <dd>{{item.free_field.weight}}</dd>
            </dl>
            <dl>
              <dt>{{$t("DETAIL_FATHER_LABEL")}}</dt>
              <dd>{{item.free_field.father}}</dd>
            </dl>
          </div>
          <div class="detail-block">
            <dl>
              <dt>{{$t("DETAIL_MOTHER_LABEL")}}</dt>
              <dd>{{item.free_field.mother}}</dd>
            </dl>
            <dl>
              <dt>{{$t("DETAIL_MATERNAL_GRANDFATHER_LABEL")}}</dt>
              <dd>{{item.free_field.maternal_grandfather}}</dd>
            </dl>
            <dl>
              <dt>{{$t("DETAIL_RANCHING_LABEL")}}</dt>
              <dd>{{item.free_field.ranching}}</dd>
            </dl>
            <dl>
              <dt>{{$t("DETAIL_TOTAL_ACHIEVEMENT_LABEL")}}</dt>
              <dd>{{item.free_field.total_achievements}}</dd>
            </dl>
          </div>
          <div class="detail-block">
            <dl>
              <dt>{{$t("DETAIL_CENTRAL_PRIZE_MONEY_LABEL")}}</dt>
              <dd>{{item.free_field.central_prize_money}}</dd>
            </dl>
            <dl>
              <dt>{{$t("DETAIL_LOCAL_PRIZE_MONEY_LABEL")}}</dt>
              <dd>{{item.free_field.local_prize_money}}</dd>
            </dl>
            <dl>
              <dt>{{$t("DETAIL_REMARKS_LABEL")}}</dt>
              <dd>{{item.free_field.memo}}</dd>
            </dl>
          </div>
        </div>
      </div>
    </li>
  </ul>
</section>
</template>

<script>
import Methods from '@/api/methods'
import RowBid from '../ItemList/RowBid.js'
import testData from './testData'

export default {
  props : {
    parent : {
      type    : Object,
      default : Object
    },
    getItem : {
      type    : Function,
      default : Object
    },
    favorite : {
      type    : Function,
      default : Object
    }
  },
  mixins : [RowBid],
  data() {
    return {
      constants : [],
      item      : {
        free_field : {}
      }
    }
  },
  created() {
    this.getConstants()
      .then(() => {
        this.getItemInfo()
      })
      .catch(err => {
        this.$store.state.loading = false
        Methods.parseHtmlResponseError(this.$router, error)
      })
  },
  methods : {
    getItemInfo() {
      this.$store.state.loading = true
      const params = {
        exhibitionItemNo : this.$route.params.id
      }

      // Demo
      console.log('getItemInfo')
      const data = testData.detail_auction

      /*
       * This.getItem(params)
       *  .then(data => {
       */
      this.$store.state.loading = false
      this.item = data
      /*
       * })
       * .catch((error) => {
       *   this.$store.state.loading = false
       *   this.errors = Methods.parseHtmlResponseError(this.$router, error)
       * })
       */
    },
    getConstants() {
      this.$store.state.loading = true

      // Demo
      const data = testData.constants

      /*
       * Return Methods.apiExcute('public/get-item-search-constants', this.$i18n.locale)
       *   .then(data => {
       */
      this.$store.state.loading = false
      this.constants = data // .filter(constant => constant.key_string === 'AREA_CODE')
      return Promise.resolve()
      // })
    },
    getAreaName(areaId) {
      if (this.constants) {
        const filtered_areas = this.constants.filter(x => x.value1 === areaId)
        return filtered_areas.length > 0 ? filtered_areas[0].value2 : ''
      }
      return ''
    },
    getCategory(id) {
      const tmp = testData.constants.filter(x => x.key_string === 'CATEGORY' && String(x.value1) === String(id))
      return tmp.length > 0 ? tmp[0].value2 : ''
    }
  },
  watch : {
    '$i18n.locale'() {
      this.getConstants()
        .then(() => {
          console.log('get constants')
        })
        .catch(err => {
          console.log(err)
        })
    }
  }
}
</script>

<style scoped lang="scss">
  #main.contact-used #target-item ul li .target-item-txt p.target-item-system {
    height: 32px;
    line-height: 28px;
  }
  #main.contact-used #target-item ul li .target-item-txt p.target-item-no {
    height: 32px;
  }
  #main.contact-used #target-item ul li .target-item-txt .header-info {
    width: 100%;
    display: flex;
  }
  #main.contact-used #target-item ul li .target-item-txt {
    padding: 5px 0 15px 25px;
  }
  /* ---------------------------
  スペック
  ----------------------------- */
  #main.contact-used #target-item ul li .target-item-txt .target-item-data {
    width: 100%;
  }
  #main.contact-used #target-item ul li .target-item-txt .target-item-data .detail-block {
    display: block;
    min-width: calc(100% / 3);
    padding-right: 15px;
  }
  #main.contact-used #target-item ul li .target-item-txt .target-item-data .detail-block dl {
    width: 100%;
    padding-right: 15px;
  }
  #main.contact-used #target-item ul li .target-item-txt .target-item-data .detail-block dl dd {
    line-break: anywhere;
  }

  @media only screen and (max-width: 767px) {
    #main.contact-used #target-item ul li .target-item-txt .target-item-data .detail-block{
      width: 100%;
      min-width: 0;
      margin-right: 0;
      border-bottom: 1px dashed #EAEAEA;
    }
    #main.contact-used #target-item ul li .target-item-txt .target-item-data .detail-block dl dt {
      width: 130px;
      min-width: 0;
    }
    #main.contact-used #target-item ul li .target-item-txt p.target-item-system {
      margin-top: 0;
      text-align: center;
      padding: 2px 10px;
    }
    #main.contact-used #target-item ul li .target-item-txt .header-info {
      width: 100%;
      display: flex;
      margin-top: 10px;
    }
  }
</style>
<style type="scss">
  @media only screen and (min-width: 768px) {
    #main.contact-used #target-item ul li .target-item-txt .target-item-data .detail-block dl dd.category {
      font-size: small;
    }
  }
</style>
